import * as React from 'react';
import styled from 'styled-components';
import PageTitle from '../../common/PageTitle';
import FormButtons from '../../common/FormButton';
import { ContentLogo, ContentLogoWrapper, SubTitleParagraph } from '../../common/Layout';
import { loginPageUrl } from '../../../../core/constants';
import checkGreenSquareSvg from '../../../../images/checkGreenSquare.svg';
import { useNavigateWithAppName } from '../../../common/NavigateWithAppName';
import { isBetterOffApp } from '../../../../core/appType';

const RegisterCompletionForm = () => {
	const navigate = useNavigateWithAppName();

	const handleContinueButtonClick = () => {
		navigate(loginPageUrl);
	};

	return (
		<>
			<ContentLogoWrapper>
				<ContentLogo src={checkGreenSquareSvg} alt="Check icon" />
			</ContentLogoWrapper>
			<CenteredTitle title="Account setup complete" />
			<CenteredSubTitle>
				Thanks for signing up. We&apos;ll review your details and email you when access is approved
				{isBetterOffApp() ? '.' : ' - usually within 24 hours.'}
			</CenteredSubTitle>
			<FormButtons continueButtonText="Return to login" onContinueButtonClick={handleContinueButtonClick} />
		</>
	);
};

export default RegisterCompletionForm;

const CenteredTitle = styled(PageTitle)`
	text-align: center;
`;

const CenteredSubTitle = styled(SubTitleParagraph)`
	text-align: center;
`;
